import { render, staticRenderFns } from "./BottomSheet.vue?vue&type=template&id=6b884f71"
import script from "./BottomSheet.vue?vue&type=script&lang=js"
export * from "./BottomSheet.vue?vue&type=script&lang=js"
import style0 from "./BottomSheet.vue?vue&type=style&index=0&id=6b884f71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports